//3rd Party Components
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { Link } from "react-router-dom";
import moment from 'moment';

//Components
import SortedTable from '../Portal/SortedTable';
import SharePointDownload from '../Portal/SharePointDownload';

//Actions
import { getUrlSelector, getFeatureSelector } from '../../PortalStore/Selectors/EnvDataSelectors';
import { iOSversion } from '../Portal/Utilities';

const RPAList = ({ expiryMsg, commCols, commArr, organisationId, organisationArn, organisationName, userid, downloadSPSize, showAdd, draftRPAs }) => {
    const [allowDownload, setAllowDownload] = useState(false);

    const standalone = useSelector(state => state.B2CSettings.items.standalone);
    const appsOrganisation = useSelector(state => state.appsOrganisation);
    const appsIndividual = useSelector(state => state.appsIndividual);

    let featureAddDroneASF = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Add RPA Drone ASF"));
    var addDroneASFDate = moment(featureAddDroneASF, "DD/MM/YYYY");
    var addDroneASFAvailable = addDroneASFDate.isBefore();

    // set flag for recreational drones feature
    const featureRecDrone = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Recreational Drone"));
    const isFeatureRecDrone = featureRecDrone ? moment().isSameOrAfter(moment(featureRecDrone, 'DD/MM/YYYY')) : false;

    let crumbs = [];
    let crumbsRenew = [];
    let crumb = {};

    let params = {
        'breadcrumbs': crumbs
    };

    let paramsRenew = {
        'breadcrumbs': crumbsRenew
    };

    if (organisationId !== "") {
        params.organisationId = organisationId;
        params.organisationArn = organisationArn;
        params.organisationName = organisationName;

        paramsRenew.organisationId = organisationId;
        paramsRenew.organisationArn = organisationArn;
        paramsRenew.organisationName = organisationName;
        crumb = {
            link: '/forms/dashorg?standalone=' + standalone + '&casaorgid=' + organisationId, //add forms if local
            text: 'myCASA'
        };
        crumbs.push(crumb);
        crumbsRenew.push(crumb);
        crumb = {
            text: 'Manage registered <abbr title="Remotely piloted aircraft">drone</abbr>s',
            link: '/forms/orgmanagerpa?standalone=' + standalone + '&casaorgid=' + organisationId
        }
        crumbs.push(crumb);
        crumbsRenew.push(crumb);
        crumb = {
            text: 'Renew <abbr title="Remotely piloted aircraft">drone</abbr> registration',
        }
        crumbsRenew.push(crumb);
    }
    else {
        params.organisationId = "";
        paramsRenew.organisationId = "";
        crumb = {
            link: '/dashind?standalone=' + standalone, //add forms if local
            text: 'myCASA'
        };
        crumbs.push(crumb);
        crumbsRenew.push(crumb);
        crumb = {
            text: 'Manage registered <abbr title="Remotely piloted aircraft">drone</abbr>s',
            link: '/forms/indmanagerpa?standalone=' + standalone
        }
        crumbs.push(crumb);
        crumbsRenew.push(crumb);
        crumb = {
            text: 'Renew <abbr title="Remotely piloted aircraft">drone</abbr> registration',
        }
        crumbsRenew.push(crumb);
    }

    const aemURL = useSelector(state => getUrlSelector(state, 'Portal - AEM URL'));
    const rpaApplyURL = useSelector(state => getUrlSelector(state, 'Portal - AEM RPA Apply URL'));
    let sethrefAdd = '';
    if (addDroneASFAvailable) {
        sethrefAdd = organisationId !== "" ? `/organisation/${organisationId}/drone-registration` : '/drone-registration';
        sethrefAdd += "?standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(params)));
    }
    else {
        sethrefAdd = aemURL + rpaApplyURL + "?params=" + encodeURIComponent(btoa(JSON.stringify(params)));
    }

    let sethrefRenew = "";
    if (organisationId !== "") {
        paramsRenew.from = "org";
        sethrefRenew = `/organisation/${organisationId}/drone-renewal` + "?standalone=" + standalone;
    }
    else {
        paramsRenew.from = "ind";
        sethrefRenew = '/drone-renewal' + "?standalone=" + standalone;
    }

    //display rules
    // add - 
    //     no draft reg app 
    //     no renewals in progress
    // renew -
    //     no draft reg app 
    //     no renewals in progress
    //     has one or more drones with an expiry date within 30 days of todays date (past or future)
    let showRenewButton = false;
    let showAddButton = true;

    if (organisationId !== "") {
        if (appsOrganisation && appsOrganisation.items && appsOrganisation.items.inprogrenewaldrones && appsOrganisation.items.inprogrenewaldrones.length > 0) {
            showAddButton = false;
        }
        else {
            for (let i = 0; i < commArr.length; i++) {
                if (commArr[i].msg === "Expiring soon" || commArr[i].msg === "Expired") {
                    showRenewButton = true;
                }
            }
        }
    }
    else {
        if (appsIndividual && appsIndividual.items && appsIndividual.items.inprogrenewaldrones && appsIndividual.items.inprogrenewaldrones.length > 0) {
            showAddButton = false;
        }
        else {
            //do a find
            let found = commArr.findIndex(d => d.msg === "Expiring soon" || d.msg === "Expired");
            if (found > -1) {
                showRenewButton = true;
            }
        }
    }

    if (draftRPAs && draftRPAs.length > 0) {
        showAddButton = false;
        showRenewButton = false;
    }

    const showAdd1 = (showAdd, commArr) => {
        if (showAdd && (commArr.length > 0)) {
            return (

                <div className="au-form-group">
                    {showAddButton ? <Link
                        id="add1"
                        className="au-btn au-btn--darker btn-Hollow"
                        to={sethrefAdd}>

                        <span>
                            Add <abbr title='Remotely piloted aircraft'>drone</abbr>
                        </span>
                    </Link> : null}
                    &nbsp;&nbsp;
                    {showRenewButton ? <Link
                        id="renew1"
                        className="au-btn au-btn--darker btn-Hollow"
                        to={sethrefRenew}>

                        <span>
                            Renew <abbr title='Remotely piloted aircraft'>drones</abbr>
                        </span>

                        <br />
                    </Link> : null}
                </div>
            );
        }
        else {
            return null;
        }
    }

    const showAdd2 = (showAdd, commArr) => {

        if (showAdd && (commArr.length > 0)) {
            return (
                <div className="au-form-group">
                    {showAddButton ? <Link
                        id="add2"
                        className="au-btn au-btn--darker btn-Hollow"
                        to={sethrefAdd}>

                        <span>
                            Add <abbr title='Remotely piloted aircraft'>drone</abbr>
                        </span>

                        <br />
                    </Link> : null}
                    &nbsp;&nbsp;
                    {showRenewButton ? <Link
                        id="renew2"
                        className="au-btn au-btn--darker btn-Hollow"
                        to={sethrefRenew}>

                        <span>
                            Renew <abbr title='Remotely piloted aircraft'>drones</abbr>
                        </span>

                        <br />
                    </Link> : null}
                </div>
            )
        }
        else {
            return null
        }
    }

    const showDroneTable = (commArr, commCols, expiryMsg, title) => {
        if (commArr.length > 0) {
            return (
                <div id="commrpa" className="table-detail">
                    <SortedTable
                        data={commArr}
                        cols={commCols}
                        caption={title}
                        sortby="name"
                        order="asc"
                        subcaption={expiryMsg}
                        showIfEmpty={false}
                    />
                </div>)
        }
        return;
    }

    const downloadSP = () => {
        setAllowDownload(true);
    }

    const createDownload = () => {
        if (allowDownload) {
            let ios = iOSversion();
            let entity = '';
            let id = '';
            if (organisationId !== '') {
                entity = 'account';
                id = organisationId;
            }
            else {
                entity = 'contact';
                id = userid;
            }
            let file = '';
            return (
                <SharePointDownload entity={entity} file={file} id={id} ios={ios} load={setAllowDownload} />
            )
        }
        else {
            return null;
        }
    }

    return (
        <div>

            {showAdd1(showAdd, commArr)}

            {downloadSPSize > 0 ?
                <span
                    id="regdocs"
                    className="download-icon"
                    style={{ float: 'right' }}
                    align='right'>

                    <button style={{ backgroundColor: 'white', borderWidth: 0, paddingRight: 0 }} className="ismall i i-PDF" onClick={downloadSP} />

                    <button onClick={downloadSP} className="btn-link">
                        Download registration certificate (<abbr title='Portable Document Format'>PDF</abbr> {downloadSPSize}KB)
                    </button>

                    <br />

                    <div
                        id="msg-popup"
                        style={{ float: 'right' }}
                        align='right'>
                        You may need to enable popups in your browser to download your certificate
                    </div>

                    {createDownload()}

                    <br />

                </span>
                : null
            }

            <div className="au-form-group">

                <div className="col-xs-12">

                    {isFeatureRecDrone ? showDroneTable(commArr.filter(drone => drone.regtype === "Recreational"), commCols, expiryMsg, "Recreational drones and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>") : ''}
                    {showDroneTable(commArr.filter(drone => drone.regtype === "Commercial"), commCols, expiryMsg, "Commercial drones and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>")}

                </div>

            </div>

            {showAdd2(showAdd, commArr)}

            <br />
        </div>
    )
}

RPAList.propTypes = {
    commCols: PropTypes.array.isRequired,
    commArr: PropTypes.array.isRequired,
    expiryMsg: PropTypes.string.isRequired,
    organisationId: PropTypes.string,
    organisationArn: PropTypes.string,
    organisationName: PropTypes.string,
    userid: PropTypes.string.isRequired,
    downloadSPSize: PropTypes.number.isRequired,
    showAdd: PropTypes.bool.isRequired,
    draftRPAs: PropTypes.array.isRequired,
    attributeOptions: PropTypes.object
};

RPAList.defaultProps = {
    organisationId: "",
    organisationArn: '',
    organisationName: '',
    showAdd: true
};

export default RPAList;